/**
 * 
 * @param {Object} request 
 * request.url - URL of the API request
 * request.options - options like `credentials: "include"`
 * request.header - header to be attached in the request. If not present, default header with 
 *                  Authorization token_2 and Content-Type application/json will be taken 
 * @param {Function} callback to handle the response of the request
 */

import { OXE_DISCONNECTION, TOKEN_2 } from "./Constants"
import { getSessionItem } from "./storageUtils"
import store from "../store/store"
import { handleOXEDisconnection } from "../store/actions/OxeActions"


export const getRequest = (request, callback) => {
    // console.log(`${new Date()}: GET-SENT ${request.url}`)
    const headers = request.header ?? getHeaders()
    fetch(request.url, {
        method: "GET",
        headers: {...headers, 'Accept-Language': getSessionItem("language")},
        ...{ ...request.options }
    })
        .then((response) => {
            // console.log(`${new Date()}: GET-RECEIVED ${request.url}`)
            if (response.status === 401) {
                // Handle the 401 error
                console.error('Unauthorized request')
                handle401Response(response, callback)
            } else {
                // If the response is OK, process the response
                return response.json() // or response.text() based on your need
            }
        }).then(data => {
            callback(data, true)
        }).catch((error) => {
            console.log(error)
            callback(error, false)
        })
}

export const postRequest = (request, callback) => {
    // console.log(`${new Date()}: POST-SENT ${request.url}`)
    const headers = request.header ?? getHeaders()
    fetch(request.url, {
        method: "POST",
        body: request.bodyData,
        headers: {...headers, 'Accept-Language': getSessionItem("language")},
        ...{ ...request.options }
    })
        .then((response) => {
            // console.log(`${new Date()}: POST-RECEIVED ${request.url}`)
            if (response.status === 401) {
                // Handle the 401 error
                console.error('Unauthorized request')
                handle401Response(response, callback)
            } else {
                // If the response is OK, process the response
                return response.json() // or response.text() based on your need
            }
        }).then(data => {
            callback(data, true)
        }).catch((error) => {
            console.log(error)
            callback(error, false)
        })
}

export const putRequest = (request, callback) => {
    // console.log(`${new Date()}: PUT-SENT ${request.url}`)
    const headers = request.header ?? getHeaders()
    fetch(request.url, {
        method: "PUT",
        body: request.bodyData,
        headers: {...headers, 'Accept-Language': getSessionItem("language")},
    })
        .then((response) => {
            // console.log(`${new Date()}: PUT-RECEIVED ${request.url}`)
            if (response.status === 401) {
                // Handle the 401 error
                console.error('Unauthorized request')
                handle401Response(response, callback)
            } else {
                // If the response is OK, process the response
                return response.json() // or response.text() based on your need
            }
        }).then(data => {
            callback(data, true)
        }).catch((error) => {
            console.log(error)
            callback(error, false)
        })
}

export const deleteRequest = (request, callback) => {
    // console.log(`${new Date()}: DELETE-SENT ${request.url}`)
    const headers = request.header ?? getHeaders()
    fetch(request.url, {
        method: "DELETE",
        headers: {...headers, 'Accept-Language': getSessionItem("language")},
    })
        .then((response) => {
            // console.log(`${new Date()}: DELETE-RECEIVED ${request.url}`)
            if (response.status === 401) {
                // Handle the 401 error
                console.error('Unauthorized request')
                handle401Response(response, callback)
            } else {
                // If the response is OK, process the response
                return response.json() // or response.text() based on your need
            }
        }).then(data => {
            callback(data, true)
        }).catch((error) => {
            console.log(error)
            callback(error, false)
        })
}

// Default header
const getHeaders = () => {

    return {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getSessionItem(TOKEN_2)}`
    }
}

// Handle 401 response from server based on errorCode. Default fallback action will be logout of UMC 
const handle401Response = async (response, callback) => {
    try {
        const data = await response.json()
        if (data.errorCode === OXE_DISCONNECTION) {
            store.dispatch(handleOXEDisconnection())
            callback(data.errorCode, false)
        } else {
            window.location = "/logout"
        }
    } catch(err) {
        window.location = "/logout"
    }
}
